import React, { useEffect, useState } from 'react';
import Modal from '../components/overlay/Modal';
import Subheading from '../components/font/Subheading';

import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../redux/redux.hooks';
import { createOrUpdateCoupon, getCoupons } from '../reducers/coupon.reducer';
import CouponCard from '../components/coupon/CouponCard';
import { CreateOrUpdateCouponRequest } from '../requests/create.or.update.coupon.request';
import { P } from '../components/font/Parargraph';
import { useLoggedIn } from '../hooks/use.logged.in';
import Row from '../components/layout/Row';
import ColumnItem from '../components/layout/ColumnItem';
import { Switch } from 'antd';
import RadioButtonWrapper from '../components/radio/RadioButtonWrapper';
import RadioButton from '../components/radio/RadioButton';
import RadioButtonContent from '../components/radio/RadioButtonContent';
import { Coupon } from '../models/coupon';
import HomeButton from '../components/header/HomeButton';
import { useToast } from '../components/toast/ToastProvider';

const initialCouponRequest: CreateOrUpdateCouponRequest = {
  active: true,
  code: '',
  value: 0,
  duration: 1,
  expiry: 1,
  reuse_amount: 1,
  trial_days: 0,
};

type Filter = 'Recent' | 'All' | 'Valid' | 'Expired';

const Coupons = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { data, status, createCouponStatus } = useAppSelector(
    (state) => state.couponReducer
  );
  const [codeHasError, setCodeHasError] = useState(false);
  const [valueHasError, setValueHasError] = useState(false);
  const [durationHasEror, setDurationHasError] = useState(false);
  const [expiryHasError, setExpiryHasError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState<Filter>('Recent');
  const [filteredData, setFilteredData] = useState<Coupon[]>([]);
  const [createCouponRequest, setCreateCouponRequest] =
    useState<CreateOrUpdateCouponRequest>(initialCouponRequest);

  const codeError = 'Please enter the coupon name. Hint: ABBR70';
  const valueError = 'The coupon cannot have a value of 0';
  const durationError = 'Please the coupon can not be valid for 0 days.';
  const expiryError =
    'The shop should have at least 1 day to apply the coupon.';

  useLoggedIn();

  const handleAddCouponClick = () => {
    setCreateCouponRequest(initialCouponRequest);
    setShowModal(true);
  };

  const handleModalSubmit = () => {
    dispatch(createOrUpdateCoupon(createCouponRequest));
  };

  const handleActiveToggle = () => {
    setCreateCouponRequest((prev) => ({
      ...createCouponRequest,
      active: !prev.active,
    }));
  };

  const handleEditClick = (request: CreateOrUpdateCouponRequest) => {
    setCreateCouponRequest(request);
    setShowModal(true);
  };

  const renderFilterList = () => (
    <Row>
      <ColumnItem>
        <Row>
          <RadioButtonWrapper>
            <RadioButton
              groupName='filter'
              value='recent'
              checked={filter === 'Recent'}
              onClick={() => setFilter('Recent')}
              content={() => <RadioButtonContent>Recent (Expired less than 3 months ago)</RadioButtonContent>}
            />
          </RadioButtonWrapper>
          <RadioButtonWrapper>
            <RadioButton
              groupName='filter'
              value='all'
              checked={filter === 'All'}
              onClick={() => setFilter('All')}
              content={() => <RadioButtonContent>All</RadioButtonContent>}
            />
          </RadioButtonWrapper>
          <RadioButtonWrapper>
            <RadioButton
              groupName='filter'
              value='valid'
              checked={filter === 'Valid'}
              onClick={() => setFilter('Valid')}
              content={() => <RadioButtonContent>Valid</RadioButtonContent>}
            />
          </RadioButtonWrapper>
          <RadioButtonWrapper>
            <RadioButton
              groupName='filter'
              value='expired'
              checked={filter === 'Expired'}
              onClick={() => setFilter('Expired')}
              content={() => <RadioButtonContent>Expired</RadioButtonContent>}
            />
          </RadioButtonWrapper>
        </Row>
      </ColumnItem>
    </Row>
  );

  const renderCardItems = () => {
    const redColor = '#7e0b0b';

    return (
      <div style={{  'margin': 'auto' }}>
        <s-section padding='none' accessibilityLabel='Coupons'>
          <CouponList>
            {filteredData.map((item) => {
              const {id, active, code, discount, expiration_date, trial_days, uses_left} = item;
            
              const discountRegex = /value:\s*{\s*percentage:\s*(\d+\.?\d*)/;
              const validityRegex = /durationLimitInIntervals:\s*(\d+)/;
              const discountRegexMatcher = discount.match(discountRegex);
              const validityRegexMatcher = discount.match(validityRegex);
            
              const dateTillExpiry = new Date(expiration_date.split('T')[0]).getTime() - new Date().getTime();
              const expiry = Math.max(Math.ceil(dateTillExpiry / (1000 * 3600 * 24)), 0);

              return (
                <CouponItem key={id}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <s-button-group>
                      <s-button slot='secondary-actions' onClick={() => {
                        handleEditClick({
                          id,
                          code,
                          duration: validityRegexMatcher ? +validityRegexMatcher[1] : 1,
                          value: (discountRegexMatcher ? +discountRegexMatcher[1] : 0.1) * 100,
                          active,
                          expiry,
                          reuse_amount: uses_left,
                          trial_days,
                        })
                      }}>Edit</s-button>
                      <s-button slot='secondary-actions' onClick={() => { navigator.clipboard.writeText(code) }}>Copy</s-button>
                    </s-button-group>
                    <div style={{ width: '300px', paddingLeft: '15px' }}><b>{code}</b></div>
                    <div style={{ width: '100px', color: expiry === 0 ? redColor : '#333' }}>{expiry === 0 ? 'Expired' : `${expiry} days`}</div>
                    <div style={{ width: '150px' }}>Discount: {(discountRegexMatcher ? +discountRegexMatcher[1] : 0.1) * 100}%</div>
                    <div style={{ width: '150px' }}>Lasts: {validityRegexMatcher ? +validityRegexMatcher[1] : 1} months</div>
                    <div style={{ width: '110px' }}>Trial: {trial_days} days</div>
                    <div style={{ width: '100px' }}><s>Uses: {uses_left}</s></div>
                  </div>
                </CouponItem>
              );
            })}
          </CouponList>
        </s-section>
      </div>
    )
    // return (
    //   <>
    //     {filteredData &&
    //       filteredData.map((coupon) => {
    //         const discountRegex = /value:\s*{\s*percentage:\s*(\d+\.?\d*)/;
    //         const validityRegex = /durationLimitInIntervals:\s*(\d+)/;
    //         const discountRegexMatcher = coupon.discount.match(discountRegex);
    //         const validityRegexMatcher = coupon.discount.match(validityRegex);
    //         const discount = discountRegexMatcher
    //           ? +discountRegexMatcher[1]
    //           : 0.1;
    //         const validity = validityRegexMatcher
    //           ? +validityRegexMatcher[1]
    //           : 1;
    //         return (
    //           <CouponCard
    //             key={coupon.id}
    //             code={coupon.code}
    //             duration={validity}
    //             expires={coupon.expiration_date.split('T')[0]}
    //             usesLeft={coupon.uses_left}
    //             value={discount * 100}
    //             active={coupon.active}
    //             trial_days={coupon.trial_days}
    //             onEditClick={handleEditClick}
    //           />
    //         );
    //       })}
    //   </>
    // );
  };

  const generateRandomString = (length: number) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}

  const renderModal = () => {
    return (
      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        heading='Create/Update Coupon'
        primaryAction={{
          content: 'Create/Update Coupon',
          onAction: handleModalSubmit,
          loading: createCouponStatus === 'loading',
          disabled:
            codeHasError || valueHasError || expiryHasError || durationHasEror,
        }}
      >
        <>
          <Row>
            <ColumnItem>
              <s-button disabled={createCouponRequest?.id != undefined} onClick={() => {
                setCreateCouponRequest({
                  ...createCouponRequest,
                  code: generateRandomString(16),
                });
              }}>Randomise code</s-button>
            </ColumnItem>
          </Row>
          <Row>
            <ColumnItem>
              <s-text-field
                id='code'
                name='code'
                label='COUPON NAME'
                value={createCouponRequest?.code}
                onInput={({ currentTarget: { value: ev } }) => {
                  setCreateCouponRequest({
                    ...createCouponRequest,
                    code: ev,
                  });
                }}
                onBlur={() =>
                  setCodeHasError(createCouponRequest?.code === '')
                }
                error={codeHasError ? codeError : ''}
                autocomplete='off'
              />
            </ColumnItem>
            <ColumnItem>
              <s-number-field
                id='value'
                name='value'
                label='COUPON VALUE'
                value={createCouponRequest?.value?.toString()}
                onInput={({ currentTarget: { value: ev } }) => {
                  setCreateCouponRequest({
                    ...createCouponRequest,
                    value: +ev,
                  });
                }}
                onBlur={() =>
                  setValueHasError(createCouponRequest?.value === 0)
                }
                error={valueHasError ? valueError : ''}
                autocomplete='off'
              />
            </ColumnItem>
          </Row>
          <Row>
            <ColumnItem>
              <s-number-field
                id='duraton'
                name='duration'
                label='DURATION (in months)'
                value={createCouponRequest?.duration?.toString()}
                onInput={({ currentTarget: { value: ev } }) => {
                  setCreateCouponRequest({
                    ...createCouponRequest,
                    duration: +ev,
                  });
                }}
                onBlur={() =>
                  setDurationHasError(createCouponRequest?.duration === 0)
                }
                error={durationHasEror ? durationError : ''}
                autocomplete='off'
              />
            </ColumnItem>
            <ColumnItem>
              <s-number-field
                id='reuse'
                name='reuse_amount'
                label='REUSE AMOUNT (not working atm)'
                value={createCouponRequest?.reuse_amount?.toString()}
                onInput={({ currentTarget: { value: ev } }) => {
                  setCreateCouponRequest({
                    ...createCouponRequest,
                    reuse_amount: +ev,
                  });
                }}
                autocomplete='off'
              />
            </ColumnItem>
          </Row>
          <Row>
            <ColumnItem>
              <s-number-field
                id='expiry'
                name='expiry'
                label='EXPIRY (in days)'
                value={createCouponRequest?.expiry?.toString()}
                onInput={({ currentTarget: { value: ev } }) => {
                  setCreateCouponRequest({
                    ...createCouponRequest,
                    expiry: +ev,
                  });
                }}
                autocomplete='off'
              />
            </ColumnItem>
            <ColumnItem>
              <s-number-field
                id='trial_days'
                name='trial_days'
                label='Trial (in days)'
                value={createCouponRequest?.trial_days?.toString()}
                onInput={({ currentTarget: { value: ev } }) => {
                  setCreateCouponRequest({
                    ...createCouponRequest,
                    trial_days: +ev,
                  });
                }}
                autocomplete='off'
              />
            </ColumnItem>
          </Row>
            <ColumnItem>
              <Subheading>ACTIVE</Subheading>
              <Switch
                onChange={handleActiveToggle}
                checked={createCouponRequest?.active}
                style={{
                  backgroundColor: createCouponRequest?.active
                    ? '#315f46'
                    : '#ccc',
                }}
              />
            </ColumnItem>
        </>
      </Modal>
    );
  };

  const renderPage = () => {
    if (status === 'loading') {
      return (
        <TextWrapper>
          <s-spinner accessibilityLabel='Loading coupons' size='large' />
        </TextWrapper>
      );
    }
    return (
      <PageWrapper>
        {renderCardItems()}
      </PageWrapper>
    );
  };

  useEffect(() => {
    dispatch(getCoupons());
  }, [dispatch]);

  useEffect(() => {
    if (!data) return

    if (filter === 'All') {
      setFilteredData(data);
    } else if (filter === 'Valid') {
      setFilteredData(
        data.filter(
          (c) => new Date(c.expiration_date).getTime() > new Date().getTime()
        )
      );
    } else if (filter === 'Expired') {
      setFilteredData(
        data.filter(
          (c) => new Date(c.expiration_date).getTime() < new Date().getTime()
        )
      );
    } else {
      let dateFilter = new Date()
      dateFilter.setMonth(dateFilter.getMonth() - 3)
      setFilteredData(
        data.filter((c) => {
          return new Date(c.expiration_date).getTime() > dateFilter.getTime()
        })
      );
    }
  }, [filter, data]);

  useEffect(() => {
    if (createCouponStatus === 'successful') {
      setShowModal(false);
      toast.show('Created coupon successfully 💃');
      dispatch(getCoupons())
    } else if (createCouponStatus === 'error') {
      toast.show('Failed to create the coupon 😢', { isError: true });
    }
  }, [createCouponStatus, toast]);

  useEffect(() => {
    if (status === 'error') {
      toast.show('Failed to load the coupons 😢', { isError: true });
    }
  }, [status, toast]);

  return (
    <s-page inlineSize='large'>
      <HomeButton title="Coupons" />
      {showModal && renderModal()}
      {renderFilterList()}
      {renderPage()}
      <CreateCouponButton onClick={handleAddCouponClick}>
        <P>Add coupons</P>
      </CreateCouponButton>
    </s-page>
  );
};

export default Coupons;

const PageWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100vw;
  padding: 20px;
`;

const CreateCouponButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  padding-top: 12px;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 36px;
  bottom: 48px;
  right: 48px;
  color: #315f46;
  background-color: white;
  text-align: center;
  box-shadow: 4px 4px 10px #939794cc;
  cursor: pointer;
`;

const TextWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Replaces Polaris React's ResourceList: one divided row per coupon.
const CouponList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const CouponItem = styled.li`
  padding: 12px 16px;

  & + & {
    border-top: 1px solid #e1e3e5;
  }
`;
